/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  FETCHING_ORGANISATIONS,
  SET_ORGANISATIONS,
  SET_ORGANISATION,
  SET_ORGANISATION_FEATURES,
  SET_ORGANISATION_CURRENCIES,
  SET_FILTERS_SHOW_ALL_CHILD_ORGANISATIONS,
  SET_ORGANISATION_PAYMENT_METHODS,
  SET_ORGANISATION_UNPAID,
  SET_ORGANISATION_INTEGRATIONS,
  SET_ORGANISATION_SURCHARGING,
  SET_ORGANISATION_DEFAULTS,
  SET_CARD_TYPES,
  SET_ADMIN_MODE,
} from 'src/actions/organisationActions';

const initialState = {
  organisation: null,
  is_admin: false,
  organisations: [],
  fetching_organisations: false,
  features: [],
  currencies: [],
  payment_methods: [],
  defaults: {},
  card_types: [],
  filtering: {
    show_all_child_organisations: false,
  },
  integrations: [],
  unpaid_invoice: false,
  surcharging_enabled: false,
  god_mode_enabled: false,
};

export const FELLOH_ID = 'X1234';

const organisationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ORGANISATION_UNPAID: {
      return produce(state, (draft) => {
        draft.unpaid_invoice = action.payload;
      });
    }

    case SET_ORGANISATION_SURCHARGING: {
      return produce(state, (draft) => {
        draft.surcharging_enabled = action.payload;
      });
    }

    case SET_ORGANISATION_DEFAULTS: {
      return produce(state, (draft) => {
        draft.defaults = action.payload;
      });
    }

    case FETCHING_ORGANISATIONS: {
      return produce(state, (draft) => {
        draft.fetching_organisations = action.payload;
      });
    }

    case SET_ORGANISATIONS: {
      return produce(state, (draft) => {
        draft.organisations = action.payload;

        if (state.god_mode_enabled && state.god_mode_enabled === true) {
          draft.is_admin = action.payload.map((org) => org.id).includes(FELLOH_ID);
        } else {
          draft.is_admin = false;
        }
      });
    }

    case SET_ADMIN_MODE: {
      return produce(state, (draft) => {
        draft.god_mode_enabled = action.payload;
        
        if (action.payload === true && state.organisations.length > 0 && state.organisations.map((org) => org.id).includes(FELLOH_ID)) {
          draft.is_admin = true;
        } else {
          draft.is_admin = false
        }
      });
    }

    case SET_ORGANISATION: {
      return produce(state, (draft) => {
        draft.organisation = action.payload;
      });
    }

    case SET_ORGANISATION_FEATURES: {
      return produce(state, (draft) => {
        draft.features = action.payload;
      });
    }

    case SET_ORGANISATION_CURRENCIES: {
      return produce(state, (draft) => {
        draft.currencies = action.payload;
      });
    }

    case SET_ORGANISATION_PAYMENT_METHODS: {
      return produce(state, (draft) => {
        draft.payment_methods = action.payload;
      });
    }

    case SET_CARD_TYPES: {
      return produce(state, (draft) => {
        draft.card_types = action.payload;
      });
    }

    case SET_FILTERS_SHOW_ALL_CHILD_ORGANISATIONS: {
      return produce(state, (draft) => {
        draft.filtering.child_organisations_filtered = action.payload;
      });
    }

    case SET_ORGANISATION_INTEGRATIONS: {
      return produce(state, (draft) => {
        draft.integrations = action.payload;
      });
    }

    default: {
      return state;
    }
  }
};

export default organisationReducer;
